import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DocusignDialogComponent } from './view/docusign-dialog/docusign-dialog.component';
import { EnvelopsDialogComponent } from './view/envelops-dialog/envelops-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MiscModule } from 'projects/core/src/lib/misc/misc.module';

@NgModule({
	declarations: [
		DocusignDialogComponent,
		EnvelopsDialogComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TableModule,
		MatDialogModule,
		MatRippleModule,
		MatIconModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule,
    MiscModule,
		MatProgressSpinnerModule
	],
	entryComponents: [
		DocusignDialogComponent,
		EnvelopsDialogComponent
	]
})
export class DocuSignModule { }
